import { FC } from "react";

import { useEmailEditorTour } from "../hooks/useEmailEditorTour";
import { EmailEditorTourProps } from "../types";

import { DashboardHighlight } from "@/dashboard-design-system/Highlight/DashboardHighlight";
import { NofieInfobox } from "@/dashboard-design-system/NofieInfobox";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { useTranslate } from "@/hooks/useTranslate";

export const EmailEditorTour: FC<EmailEditorTourProps> = ({ recipientsRef, templatesRef }) => {
  const { t } = useTranslate();
  const { isSmallScreen } = useMediaQuery();

  const { showRecipientsTour, showTemplatesTour, onRecipientsTourClose, onTemplatesTourClose, onSkipTour } =
    useEmailEditorTour();

  return (
    <>
      <DashboardHighlight
        anchorEl={recipientsRef.current}
        open={showRecipientsTour}
        onClose={onRecipientsTourClose}
        position={isSmallScreen ? "bottom" : "left"}
      >
        <NofieInfobox
          title={t("dashboard", "engagementTour.email.recipients.title")}
          buttonsProps={[
            {
              key: "skip",
              children: t("dashboard", "engagementTour.skipTour"),
              onClick: onSkipTour,
              variant: "text",
            },
            {
              key: "ok",
              children: t("dashboard", "engagementTour.okGotIt"),
              onClick: onRecipientsTourClose,
            },
          ]}
          pointer={isSmallScreen ? "top" : "right"}
          style={{ maxWidth: isSmallScreen ? "300px" : "undefined" }}
        >
          {t("dashboard", "engagementTour.email.recipients.body")}
        </NofieInfobox>
      </DashboardHighlight>
      <DashboardHighlight
        anchorEl={templatesRef.current}
        open={showTemplatesTour}
        onClose={onTemplatesTourClose}
        position={isSmallScreen ? "bottom" : "left"}
      >
        <NofieInfobox
          title={t("dashboard", "engagementTour.email.templates.title")}
          buttonsProps={[
            {
              key: "ok",
              children: t("dashboard", "engagementTour.okGotIt"),
              onClick: onTemplatesTourClose,
            },
          ]}
          pointer={isSmallScreen ? "top" : "right"}
          style={{ maxWidth: isSmallScreen ? "300px" : "undefined" }}
        >
          {t("dashboard", "engagementTour.email.templates.body")}
        </NofieInfobox>
      </DashboardHighlight>
    </>
  );
};
